import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { BackendAsAServiceClient } from './backend-as-a-service-client.js';

export function useBackendAsAServiceClient(): BackendAsAServiceClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(
    () => new BackendAsAServiceClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
